import { defineMessages } from 'react-intl';

export const validationTypesMessages = defineMessages({
    validationTypes: {
        id: 'validation-types',
        defaultMessage: 'Validation types',
    },
    validationType: {
        id: 'validation-type',
        defaultMessage: 'Validation type',
    },
    types: {
        id: 'types',
        defaultMessage: 'Types',
    },
    type: {
        id: 'type',
        defaultMessage: 'Type',
    },
    time: {
        id: 'time',
        defaultMessage: 'Time',
    },
    charge: {
        id: 'charge',
        defaultMessage: 'Charge',
    },
    waive: {
        id: 'waive',
        defaultMessage: 'Waive',
    },
    guest: {
        id: 'guest',
        defaultMessage: 'Guest',
    },
    canBeStacked: {
        id: 'can-be-stacked',
        defaultMessage: 'Can be stacked',
    },
    canBeCombined: {
        id: 'can-be-combined',
        defaultMessage: 'Can be combined',
    },
    code: {
        id: 'code',
        defaultMessage: 'Code',
    },
    validationTypeAmount: {
        id: 'validation-type-amount',
        defaultMessage: 'Amount',
    },
    amountInMinutes: {
        id: 'amount-in-minutes',
        defaultMessage: 'Amount in minutes',
    },
    createValidationTypeSuccess: {
        id: 'create-validation-type-success',
        defaultMessage: 'Validation type created',
    },
    createValidationTypeSuccessDescription: {
        id: 'create-validation-type-success-description',
        defaultMessage: 'A new validation type has been successfully created.',
    },
    newValidationType: {
        id: 'add-new-validation-type',
        defaultMessage: 'New validation type',
    },
    addValidationTypeModalSubtitle: {
        id: 'add-validation-type-modal-subtitle',
        defaultMessage: 'Add a new validation type',
    },
    validations: {
        id: 'validations',
        defaultMessage: 'Validations',
    },
    deleteValidationType: {
        id: 'delete-validation-type',
        defaultMessage: 'Delete validation type',
    },
    deleteValidationTypeSubtitle: {
        id: 'delete-validation-type-subtitle',
        defaultMessage: 'Permanently delete type {type}',
    },
    confirmDeleteValidationType: {
        id: 'confirm-delete-validation-type',
        defaultMessage: 'Are you sure you want to delete validation type {type}? This action cannot be undone.',
    },
    deleteValidationTypeSuccess: {
        id: 'delete-validation-type-success',
        defaultMessage: 'Validation type deleted',
    },
    deleteValidationTypeSuccessDescription: {
        id: 'delete-validation-type-success-description',
        defaultMessage: 'Validation type {type} has been successfully deleted.',
    },
    editValidationType: {
        id: 'edit-validation-type',
        defaultMessage: 'Edit validation type',
    },
    editValidationTypeSubtitle: {
        id: 'edit-validation-type-subtitle',
        defaultMessage: 'Edit type details for {type}',
    },
    updateValidationTypeSuccess: {
        id: 'update-validation-type-success',
        defaultMessage: 'Validation type updated',
    },
    updateValidationTypeSuccessDescription: {
        id: 'update-validation-type-success-description',
        defaultMessage: 'The type has been successfully updated.',
    },
    validationTypeDeleteError: {
        id: 'custom-error:validation_type_cannot_edit_or_delete',
        defaultMessage: 'A validation type which have validations cannot be edited or deleted!',
    },
    validatedBy: {
        id: 'validated-by',
        defaultMessage: 'Validated by',
    },
    mainIdentifier: {
        id: 'main-identifier',
        defaultMessage: 'Main identifier',
    },
    owner: {
        id: 'owner',
        defaultMessage: 'Owner',
    },
    visitor: {
        id: 'visitor',
        defaultMessage: 'Visitor',
    },
    timeToLeave: {
        id: 'time-to-leave',
        defaultMessage: 'Time to leave',
    },
    validationTypeMinutes: {
        id: 'validation-type-minutes',
        defaultMessage: 'Minutes',
    },
});
